import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { useStore } from "vuex";
import { addSizeToDataLayer } from "@/functions/analytics";
import DimensionInput from "@/components/UI/DimensionInput.vue";
import ShapeInputFieldsWrapper from "@/components/UI/ShapeInputFieldsWrapper.vue";
import {Props} from "@/components/ShapeType.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowDimensionInputs',
  props: {
    disabledShapes: {},
    storeShapeGetter: {},
    storeShapeUpdater: {},
    action: {},
    prefix: {},
    isCutout: { type: Boolean },
    modifierAction: {}
  },
  setup(__props: any) {

const store = useStore();
const { isCutout, action, prefix } = __props;

const dimensions = computed(() => store.getters.getMeasurements( 'arrow', isCutout ) );
const dimensionLabel = computed(() => store.getters.dimensionLabel);
const isDimensionValid = computed(() => {
	if (isCutout) {
		return store.getters.isShapeValid(isCutout) && store.getters.isCutoutGroupValid;
	}

	return store.getters.isShapeValid() && store.getters.isGroupValid;
});

const stemLength = computed({
	get: () => dimensions.value.stem_length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "stem_length",
			value: value,
		});
	},
});

const stemWidth = computed({
	get: () => dimensions.value.stem_width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "stem_width",
			value: value,
		});
	},
});

const headLength = computed({
	get: () => dimensions.value.head_length,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "head_length",
			value: value,
		});
	},
});

const headWidth = computed({
	get: () => dimensions.value.head_width,
	set: (value: string) => {
		store.dispatch(action, {
			dimension: "head_width",
			value: value,
		});
	},
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ShapeInputFieldsWrapper, null, {
    default: _withCtx(() => [
      _createVNode(DimensionInput, {
        inputRef: "arrow-stem_length",
        id: `${_ctx.prefix}measurements-arrow-stem_length`,
        name: `${_ctx.prefix}measurements[dimensions][stem_length]`,
        unit: "cm",
        label: dimensionLabel.value('stem_width', 'arrow'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}arrow-stem_length`),
        onBlur: () => _unref(addSizeToDataLayer)('stem_length', +stemLength.value, 'arrow'),
        modelValue: stemLength.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((stemLength).value = $event))
      }, null, 8, ["id", "name", "label", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "arrow-stem_width",
        id: `${_ctx.prefix}measurements-arrow-stem_width`,
        name: `${_ctx.prefix}measurements[dimensions][stem_width]`,
        unit: "cm",
        label: dimensionLabel.value('stem_height', 'arrow'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}arrow-stem_width`),
        onBlur: () => _unref(addSizeToDataLayer)('stem_width', +stemWidth.value, 'arrow'),
        modelValue: stemWidth.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((stemWidth).value = $event))
      }, null, 8, ["id", "name", "label", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "arrow-head_length",
        id: `${_ctx.prefix}measurements-arrow-head_length`,
        name: `${_ctx.prefix}measurements[dimensions][head_length]`,
        unit: "cm",
        label: dimensionLabel.value('head_width', 'arrow'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}arrow-head_length`),
        onBlur: () => _unref(addSizeToDataLayer)('head_length', +headLength.value, 'arrow'),
        modelValue: headLength.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((headLength).value = $event))
      }, null, 8, ["id", "name", "label", "invalid", "onBlur", "modelValue"]),
      _createVNode(DimensionInput, {
        inputRef: "arrow-head_width",
        id: `${_ctx.prefix}measurements-arrow-head_width`,
        name: `${_ctx.prefix}measurements[dimensions][head_width]`,
        unit: "cm",
        label: dimensionLabel.value('head_height', 'arrow'),
        invalid: !isDimensionValid.value(`${_ctx.prefix}arrow-head_width`),
        onBlur: () => _unref(addSizeToDataLayer)('head_width', +headWidth.value, 'arrow'),
        modelValue: headWidth.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((headWidth).value = $event))
      }, null, 8, ["id", "name", "label", "invalid", "onBlur", "modelValue"])
    ]),
    _: 1
  }))
}
}

})